import { CSSProperties } from 'react';

export const fullWidthInputStyle: CSSProperties = {
	width: '100%',
};

export const errorInputStyle: CSSProperties = {
	borderColor: 'var(--color-red)',
};
